import QueryStringFactory from './QueryString.factory';

class SupportFormService {
    constructor() {
        this.queryStringFactory = new QueryStringFactory();
        this.formValidation = this.formValidation.bind(this);
    }

    readeQueryParams(initState, queryString) {
        return this.queryStringFactory.create(initState, queryString);
    }

    formValidation(values) {
        const errors = {};
        const requiredMessage = 'This filed is required.';
        if (!values.fName || !values.fName.length) {
            errors['fName'] = requiredMessage;
        }
        if (!values.lName || !values.lName.length) {
            errors['lName'] = requiredMessage;
        }
        if (!values.email || !values.email.length || !this.isValidEmail(values.email)) {
            errors['email'] = requiredMessage;
        }
        if (!values.emailVerification || !values.emailVerification.length || !this.isValidEmail(values.emailVerification)) {
            errors['emailVerification'] = requiredMessage;
        }
        if (values.email !== values.emailVerification) {
            errors['emailVerification'] = 'The verification email does not match the given email address';
        }
        if (!values.subject || isNaN(values.subject)) {
            errors['subject'] = requiredMessage;
        }
        if (!values.message || !values.message.length) {
            errors['message'] = requiredMessage;
        }
        if (values.message && values.message.length > 256) {
            errors['message'] = 'The message is too large to be submitted..';
        }
        return errors;
    }

    isValidEmail(email) {
        return email.trim().match(/^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
    }

    buildFormData(formData) {
        const form = new FormData();
        for (const key in formData) {
            form.append(key, formData[key]);
        }
        form.delete('emailVerification');
        if (form.has('fbid') && form.get('fbid').length) {
            form.set('fbID', form.get('fbid'));
            form.delete('fbid');
        }
        return form;
    }

    submitFormData(formData) {
        return new Promise((resolve, reject) => {
            fetch('//' + window.location.host + '/support.php', {
                method: 'POST',
                body: this.buildFormData(formData)

            })
                .then(response => {
                    if (!response.ok || response.status !== 201) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(json => {
                    if (!json.status || json.status.type !== 'S') {
                        reject({ status: { type: 'E' } });
                    } else {
                        resolve(json);
                    }
                })
                .catch(error => {
                    console.error(error);
                    reject({ status: { type: 'E' } })
                })
        })
    }
}

export default SupportFormService;